import React from "react";

import PointTypes from "types/PointTypes";

import MapCarMarker from "components/MapCarMarker";

import MapUtils from "services/map/utils";

type Props = {
  cars: { initialized: boolean; items: PointTypes[] };
  options: {
    timestamp: number;
    zoom: number;
    radius: number;
    fill_color: { [key: string]: string };
    border_color: { [key: string]: string };
    border_weight: { [key: string]: number };
  };
};

function ParkedCarsLayers({ cars, options }: Props): JSX.Element[] {
  if (!cars?.initialized) {
    return [];
  }

  return cars?.items?.map((parkedCar, index) => {
    return (
      <MapCarMarker
        key={index}
        center={MapUtils.getNormalizedCoordinates(parkedCar.position)}
        zoom={options?.zoom}
        options={{
          ...parkedCar,
          ...(options || {}),
        }}
      />
    );
  });
}

export default ParkedCarsLayers;
